<template>

  <div style="position: relative; border-top: 3px solid #bc7527;padding: 3px;">
    <div class="tit">
      <div class="glitch" data-text="PROFESSIONAL EXPERIENCE">PROFESSIONAL EXPERIENCE</div>
    </div>
    <div class="work-box">
      <div class="job-list">
        <div :class="[choice === 'digitiamo' ? 'job-box active' : 'job-box']">
          <div class="job-box__header">
            <span>Full Stack Developer @ Digitiamo SRL</span>

            <span>2022 - Present</span>
            <q-icon v-if="choice !== 'digitiamo'" size="md" name="add" @click="choice = 'digitiamo'" />
            <q-icon v-if="choice === 'digitiamo'" size="md" name="remove" @click="choice = ''" />


          </div>
          <div class="job-box__content">
            <div class="infos">
              <div class="infos__position">
                <div>
                  <q-icon name="room" size="sm" color="teal-3" />
                  <span>Varese, Italy</span>
                </div>
                <div>
                  <q-icon name="language" size="sm" color="teal-3" />
                  <a href="https://www.digitiamo.com/" target="_blank">digitiamo.com</a>
                </div>
              </div>
              <div class="infos__descriptions">Full stack developer employed in the development of web applications.
                Nodejs languages ​​with Hapipal and Vue3 for the frontend part</div>
              <div class="infos__tools">
                <div>Vue3</div>
                <div>Python</div>
                <div>Terraform</div>
                <div>NodeJS</div>
              </div>
            </div>
            <div class="image">
              <img src="../assets/digitiamo.svg" class="img-svg" />
            </div>
          </div>
        </div>
        <div :class="[choice === 'polimi-mag' ? 'job-box active' : 'job-box']">
          <div class="job-box__header">
            <span>Master's degree @ Politecnico di Milano</span>

            <span>2019 - 2022</span>
            <q-icon v-if="choice !== 'polimi-mag'" size="md" name="add" @click="choice = 'polimi-mag'" />
            <q-icon v-if="choice === 'polimi-mag'" size="md" name="remove" @click="choice = ''" />


          </div>
          <div class="job-box__content">
            <div class="image">
              <img src="../assets/Logo_Politecnico_Milano.png" class="img-svg" />
            </div>
            <div class="infos">
              <div class="infos__position">
                <div>
                  <q-icon name="room" size="sm" color="teal-3" />
                  <span>Milan, Italy</span>
                </div>
                <div>
                  <q-icon name="language" size="sm" color="teal-3" />
                  <a href="https://www.polimi.it/" target="_blank"> polimi.it</a>
                </div>
              </div>
              <div class="infos__descriptions">I obtained a master's degree from the Milan Polytechnic specializing in
                complex systems</div>
              <div class="infos__tools">
                <div>Vue2</div>
                <div>Python</div>
                <div>Java</div>
                <div>Scheme</div>
                <div>Haskell</div>
                <div>Erlang</div>
              </div>
            </div>

          </div>
        </div>
        <div :class="[choice === 'polimi-tri' ? 'job-box active' : 'job-box']" @click="choice = 'polimi-tri'">
          <div class="job-box__header">
            <span>Bachelor degree @ Politecnico di Milano</span>
            <span>2016 - 2019</span>
            <q-icon v-if="choice !== 'polimi-tri'" size="md" name="add" @click="choice = 'polimi-tri'" />
            <q-icon v-if="choice === 'polimi-tri'" size="md" name="remove" @click="choice = ''" />


          </div>
          <div class="job-box__content">
            <div class="infos">
              <div class="infos__position">
                <div>
                  <q-icon name="room" size="sm" color="teal-3" />
                  <span>Como, Italy</span>
                </div>
                <div>
                  <q-icon name="language" size="sm" color="teal-3" />
                  <a href="https://www.polimi.it/" target="_blank"> polimi.it</a>
                </div>
              </div>
              <div class="infos__descriptions">I developed skills in design methods typical of engineering in all
                contexts for facing and solving complex problems</div>
              <div class="infos__tools">
                <div>C++</div>
                <div>Javascript</div>
                <div>SQL</div>
                <div>C</div>
                <div>Dart</div>
              </div>
            </div>
            <div class="image">
              <img src="../assets/Logo_Politecnico_Milano.png" class="img-svg" />
            </div>
          </div>
        </div>
        <div :class="[choice === 'uno-sistemi' ? 'job-box active' : 'job-box']" @click="choice = 'uno-sistemi'">
          <div class="job-box__header">
            <span>Full Stack Developer @ Uno Sistemi SRL</span>

            <span>2015</span>
            <q-icon v-if="choice !== 'uno-sistemi'" size="md" name="add" @click="choice = 'uno-sistemi'" />
            <q-icon v-if="choice === 'uno-sistemi'" size="md" name="remove" @click="choice = ''" />


          </div>
          <div class="job-box__content">
            <div class="image">
              <img src="../assets/unosis.png" />
            </div>
            <div class="infos">
              <div class="infos__position">
                <div>
                  <q-icon name="room" size="sm" color="teal-3" />
                  <span>Rho, Italy</span>
                </div>
                <div>
                  <q-icon name="language" size="sm" color="teal-3" />
                  <a href="http://www.unosistemi.com/" target="_blank"> unisistemi.com</a>
                </div>
              </div>
              <div class="infos__descriptions">Full stack developer employed in the development of management software
                in visual basic.</div>
              <div class="infos__tools">
                <div>Visual Basic</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Blob />
    </div>
  </div>
</template>

<script>
import Blob from '@/components/Blob.vue';

export default {
  name: "WorkView",
  components: { Blob },
  data() {
    return {
      choice: 'digitiamo',
    }
  },
};
</script>

<style lang="scss" scoped>
.tit {
  position: relative;
  top: 10vh;
  margin-left: 5vw;
  z-index:1;
}

.glitch {
  color: white;
  font-size: clamp(20px, 3vw, 70px);
  position: relative;
  width: 100%;
  margin: 0 0 !important;

  &.list {
    font-size: 35px;
    font-family: "Courier New", Courier, monospace;
  }
}

@keyframes noise-anim {
  $steps: 20;

  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}

.glitch:after {
  content: attr(data-text);
  position: absolute;
  left: 2px;
  text-shadow: -1px 0 red;
  top: 0;
  color: white;
  background: black;
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: noise-anim 2s infinite linear alternate-reverse;
}

@keyframes noise-anim-2 {
  $steps: 20;

  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100) + px, 9999px, random(100) + px, 0);
    }
  }
}

.glitch:before {
  content: attr(data-text);
  position: absolute;
  left: -2px;
  text-shadow: 1px 0 blue;
  top: 0;
  color: white;
  background: black;
  overflow: hidden;
  clip: rect(0, 900px, 0, 0);
  animation: noise-anim-2 3s infinite linear alternate-reverse;
}

.work-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;

  >div {
    width: 50vw;
  }
}

.job-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: rgb(255, 255, 255);
  font-weight: bold;
  font-size: .9vw;

  .job-box {
    display: flex;
    flex-direction: column;
    width: 70%;
    gap: 15px;

    &__header {
      padding: 1.2vh 0.8vh 1.2vh 1.2vh;
      border-radius: 5px;
      background: #84a69e98;
      width: 100%;
      font-size: clamp(10px, 0.9vw, 70px);
      display: flex;

      display: flex;
      justify-content: space-between;
      align-items: center;

      >span:first-child {
        width: 100%;
      }

      >span:nth-child(2) {
        width: 30%;
        text-align: right;
        margin-right: 15px;
      }
    }

    &__content {
      width: 100%;
      height: 100%;
      height: 0;
      overflow: hidden;
      transition: all .2s ease-in;
    }
  }

  .job-box.active {
    display: flex;
    flex-direction: column;
    width: 70%;

    .job-box__header {
      background: #88afa5;
      width: 100%;
    }

    .job-box__content {
      height: 20vh;
      background-color: #84a69e3d;
      margin-bottom: 15px;
    }
  }
}

.job-box__content {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;

  .image {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;

    >img {
      width: auto;
      height: auto;


      max-width: 100%;
      max-height: 100%;

    }
  }

  .img-svg {
    filter: invert(99%) sepia(4%) saturate(381%) hue-rotate(257deg) brightness(113%) contrast(100%);

  }

  .infos {
    width: 200%;
    display: flex;
    flex-direction: column;

    &__position {
      margin-top: 20px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      color: #80cbc4;
      font-weight: 300;

      >*>span,
      a {
        color: rgb(189, 189, 189);
      }
    }

    &__descriptions {
      font-weight: 400;
      font-size: 1.5vh;
      text-align: left;
      padding: 10px 0 20px 20px;
    }

    &__tools {
      display: flex;
      gap: 10px;
      justify-content: space-around;
      align-items: center;
      flex-direction: row;
      padding: 0 10px;

      >div {
        font-weight: 600;
        border: 1px solid #80cbc4;
        color: #ffffff;
        background: #80cbc38a;
        border-radius: 50vh;
        padding: 0 10px;
      }
    }
  }
}


@media only screen and (max-width: 768px) {
  .work-box {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center;

    >div:first-child {
      z-index: 1;
      width: 100vw;
    }
    >div:last-child {
      position: absolute;
      z-index: 0;
    }
  }

  .job-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: rgb(255, 255, 255);
    font-weight: bold;

    .job-box {
      display: flex;
      flex-direction: column;
      width: 70%;
      gap: 15px;

      &__header {
        padding: 1.2vh 0.8vh 1.2vh 1.2vh;
        border-radius: 5px;
        background: #84a69e98;
        width: 100%;
        font-size: clamp(10px, 0.9vw, 70px);
        display: flex;

        display: flex;
        justify-content: space-between;
        align-items: center;

        >span:first-child {
          width: 100%;
        }

        >span:nth-child(2) {
          width: 30%;
          text-align: right;
          font-size: clamp(6px, 0.9vw, 70px);
          margin-right: 15px;
        }
      }

      &__content {
        width: 100%;
        height: 100%;
        height: 0;
        font-size: clamp(6px, 0.9vw, 70px);
        overflow: hidden;
        transition: all .2s ease-in;
      }
    }

    .job-box.active {
      display: flex;
      flex-direction: column;
      width: 70%;

      .job-box__header {
        background: #88afa5;
        width: 100%;
      }

      .job-box__content {
        height: 20vh;
        background-color: #84a69e3d;
        margin-bottom: 15px;
      }
    }
  }

  .job-box__content {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;

    .image {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;

      >img {
        width: auto;
        height: auto;


        max-width: 100%;
        max-height: 100%;

      }
    }

    .img-svg {
      filter: invert(99%) sepia(4%) saturate(381%) hue-rotate(257deg) brightness(113%) contrast(100%);

    }

    .infos {
      width: 200%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &__position {
        margin-top: clamp(1px, 0.5vw, 20px);
        margin-bottom: clamp(0.5px, 0.25vw, 10px);
        display: flex;
        flex-direction: row;
        justify-content: space-between!important;
        color: #80cbc4;
        font-weight: 300;

        >*>span,
        a {
          color: rgb(189, 189, 189);
        }
      }

      &__descriptions {
        font-weight: 400;
        font-size: clamp(7px, 1.5vw, 30px);
        text-align: left;
        padding: clamp(0.5px, 0.25vw, 10px) clamp(15px, 0.5vw, 20px) clamp(5px, 0.5vw, 10px) clamp(15px, 0.5vw, 20px);
      }

      &__tools {
        display: flex;
        gap: 10px;
        justify-content: space-around;
        align-items: center;
        flex-direction: row;
        padding: 0 clamp(0.5px, 0.25vw, 10px);

        >div {
          font-weight: 600;
          border: 1px solid #80cbc4;
          color: #ffffff;
          background: #80cbc38a;
          border-radius: 50vh;
          padding: 0 clamp(0.5px, 0.25vw, 10px);
        }
      }
    }
  }

}
</style>
